import React, { useContext, useMemo } from 'react';
import { HeaderModule } from '../../components/home/HeaderModule';
import { CloudDownloadOutlined } from '@mui/icons-material';
import { Grid } from '@mui/material';
import { ModalsContext } from '../../contexts/ModalsContext';
import { ResponseForm } from '../../components/surveys/extractions/ResponseForm';
import { TabulationForm } from '../../components/surveys/extractions/TabulationForm';
import { CardExtraction } from '../../components/extractions/CardExtraction';
import { AuthContext } from '../../contexts/AuthContext';
import { encontrarModulo } from '../../helpers/encontrarModulo';
import { useModalStore } from '../../store/useModalStore';

export const QuantiumExtractions = () => {

    const { usuario: { rol: { nombre: rol }, permisos } } = useContext(AuthContext);
    // const { modalRef } = useContext(ModalsContext);
    const { openModal } = useModalStore();


    const actions = useMemo(() => {
        return encontrarModulo(permisos, 'opinA')?.actions?.map(a => (rol?.includes('admin') || a?.active) ? a : null);
    }, []);

    const cards = [
        { 
            component: (
                <CardExtraction
                    title='Extracción de respuestas'
                    description='Permite realizar la extracción de respuestas generadas en un rango de fechas determinado.'
                    action={ () => openModal(<ResponseForm />) }
                />
            )
        },
        {
            component: (
                <CardExtraction
                    title='Informe gráfico'
                    description='Permite generar un informe gráfico sobre el nivel de satisfacción y recomendación de los clientes en un rango de fechas determinado.'
                    action={ () => openModal(<TabulationForm />) }
                />
            )
        }
    ];

    return (
        <>
            <HeaderModule
                icon={ <CloudDownloadOutlined htmlColor="rgba(0, 0, 0, .6)" /> }
                title='Extracciones'
            />

            <Grid container gap={2}>
                { actions?.map((a, i) => a && <div key={ a?.name }>{ cards[i]?.component }</div> )}
            </Grid>
        </>
    )
}